import React, { useCallback, useEffect, useMemo, useState } from 'react';
import cx from 'classnames';
import Text, { TextSize } from '@move-ui/text';
import styles from './SelectBar.module.css';
export const SelectBar = ({ large, defaultSelectedValue, options, onChange, className }) => {
    var _a, _b;
    const [selected, setSelected] = useState(((_a = options.find(({ value }) => value === defaultSelectedValue)) === null || _a === void 0 ? void 0 : _a.value) ||
        ((_b = options[0]) === null || _b === void 0 ? void 0 : _b.value));
    useEffect(() => {
        import('focus-visible').catch(() => null);
    }, []);
    useEffect(() => {
        var _a, _b;
        setSelected(((_a = options.find(({ value }) => value === defaultSelectedValue)) === null || _a === void 0 ? void 0 : _a.value) ||
            ((_b = options[0]) === null || _b === void 0 ? void 0 : _b.value));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [defaultSelectedValue]);
    const handleChange = useCallback((value) => {
        setSelected(value);
        onChange === null || onChange === void 0 ? void 0 : onChange(value);
    }, [onChange]);
    const gridTemplateColumns = useMemo(() => options.map(() => '1fr').join(' '), [options]);
    const selectedIndex = useMemo(() => options.findIndex(({ value }) => value === selected), [options, selected]);
    const padding = useMemo(() => (large ? '0.375rem' : '0.1875rem'), [large]);
    return (React.createElement("ul", { role: "listbox", className: cx(className, styles.container, { [styles.large]: large }), style: { gridTemplateColumns } },
        React.createElement("li", { className: cx(styles.highlight, { [styles.large]: large }), style: {
                width: `calc(${100 / options.length}% - ${padding} * 2)`,
                left: `calc(${(100 / options.length) * selectedIndex}% + ${padding})`
            }, "aria-hidden": true }),
        options.map(({ value, label, icon, id, disabled }) => (React.createElement("li", Object.assign({ key: value, id: id, className: cx(styles.item, {
                [styles.selected]: selected === value && !disabled,
                [styles.large]: large,
                [styles.disabled]: disabled
            }), role: "option", "aria-selected": selected === value }, (disabled
            ? {
                'aria-disabled': true
            }
            : {
                onClick: () => handleChange(value),
                onKeyDown: ({ key }) => ['Enter', ' '].includes(key) && handleChange(value),
                tabIndex: 0
            })),
            icon,
            React.createElement(Text, { size: TextSize.M, bold: true }, label))))));
};
//# sourceMappingURL=SelectBar.js.map